import { Select, Skeleton } from "antd";
import { Control, useController } from "react-hook-form";

interface SelectProps {
  disabled?: boolean;
  dataOptions: any;
  dataName: string;
  loading?: boolean;
  control: Control<any>;
  rules?: any;
}

export function AutoComplete({ dataOptions, disabled, dataName, loading, control, rules }: SelectProps) {
  const { field } = useController({control, name: dataName, rules: rules})

  return (
    <>
      {
        loading ? <Skeleton.Input active={true} size="default" style={{width: '22.9rem'}} /> : <Select
        options={dataOptions}
        {...field}
        optionFilterProp="children"
        filterOption={
          (input, option) => (
            (option?.label ?? '').toString().toLowerCase().includes(input.toLowerCase()) || 
            (option?.label ?? '').normalize('NFKD').replace(/[\u0300-\u036F]/g, '').toString().toLowerCase().includes(input.toLowerCase())
          )
        }
        className="w-[22.9rem] h-[2.5rem]"
        disabled={disabled}
        showSearch
      />
      }
    </>
  );
}
